'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { ArrowRight, Download } from 'lucide-react';

export function Hero() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center py-20 px-4">
      {/* Animated Background Gradient */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary/10 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center space-y-8">
        <div className="space-y-4">
          <h1 className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-primary via-pink-400 to-primary bg-clip-text text-transparent">
            Yessma Originals
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground">
            Experience premium streaming with crystal-clear quality and unlimited entertainment
          </p>
        </div>

        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Stream your favorite content anytime, anywhere. Download the APK and start watching today.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
          <Link href="#download">
            <Button size="lg" className="bg-primary hover:bg-pink-600 text-white gap-2">
              <Download size={20} />
              Download APK
            </Button>
          </Link>
          <a
            href="#features"
            className="group inline-flex items-center gap-2 px-6 py-3 text-lg font-semibold text-primary hover:text-pink-400 transition-colors"
          >
            Learn More
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        {/* Trust Badge */}
        <div className="pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground mb-4">Trusted by thousands of users</p>
          <div className="flex justify-center gap-8 text-center flex-wrap">
            <div>
              <p className="text-2xl font-bold text-primary">1K+</p>
              <p className="text-sm text-muted-foreground">Active Users</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-secondary">4.6★</p>
              <p className="text-sm text-muted-foreground">Average Rating</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-primary">5K+</p>
              <p className="text-sm text-muted-foreground">Hours Watched</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
